import React, { useState } from 'react';
import { ApiConnectionString } from '../../../constants/ApiConntection';
import { ArrowLeftCircle, ArrowRightCircle } from 'react-bootstrap-icons';

export default function ClubImageModal({ selectedIndex, cancelModal,images }) {

 
const [currentIndex,setCurrentIndex] = useState(selectedIndex)


 
  const handleOverlayClick = (e) => {
    if (e.target.className === 'img-modal-overlay') {
      cancelModal();
    }
  };

  const increaseIndex = () => {
    if(currentIndex == images.length){
      setCurrentIndex(1)
    }else{
      setCurrentIndex(currentIndex + 1)
    }
  }

  const decreaseIndex = () => {
    if(currentIndex == 1){
      setCurrentIndex(images.length)
    }else{
      setCurrentIndex(currentIndex - 1)
    }
  }

  return (
    <div className="img-modal-overlay" onClick={handleOverlayClick}>
      <div className="img-modal-content">
        <button
          className="close-button"
          onClick={cancelModal}
          aria-label="Close"
        >
          &times;
        </button>
        <img src={`${ApiConnectionString}/api/image/${images[currentIndex - 1]?.id}`} alt="Enlarged preview" className="large-image" />
    {images.length > 1 &&         <div> 
      <ArrowLeftCircle
            size={50}
            className='pointer'
            onClick={decreaseIndex}
          />
          <ArrowRightCircle
            size={50}
            onClick={increaseIndex}
            className='pointer mx-2'
          />
        
      </div>
}
      </div>




    </div>
  );
}